import { useContext } from 'react';
import { PermissionsContext } from './PermissionsContext';
export function usePermissions() {
    const ctx = useContext(PermissionsContext);
    if (!ctx) {
        throw new Error('usePermissions must be used within a DealerPermissionsProvider');
    }
    return ctx;
}
